var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center text-md-start bg-light text-muted mt-3"},[_c('div',{staticClass:"text-center p-2",staticStyle:{"background-color":"rgba(0, 0, 0, 0.05)"}},[_c('em',[_vm._v(_vm._s(_vm.usuario))])])])}
var staticRenderFns = []

export { render, staticRenderFns }